import { ADD_CLOSEST_PARKINGS_INFO, RESET_CLOSEST_PARKINGS_INFO} from "./closestParkingsInfoReducer"

export const addClosestParkingsInfo = (data) => ({
    type: ADD_CLOSEST_PARKINGS_INFO,
    payload: data
})

export const resetClosestParkingsInfo = () => ({
    type: RESET_CLOSEST_PARKINGS_INFO,
})